import { Box, TextField, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';
import { useTranslation } from '../../../kit/useTranslation';

export default function SearchBar({ value, onChange }) {
  const { t } = useTranslation();
  return (
    <Box sx={{ px: 2, mt: -3, mb: 3 }}>
      <TextField
        fullWidth
        placeholder={t('support.searchPlaceholder')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search sx={{ color: '#9e9e9e' }} />
            </InputAdornment>
          ),
          sx: {
            borderRadius: 3,
            bgcolor: 'white',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            '& fieldset': {
              border: 'none',
            },
          },
        }}
      />
    </Box>
  );
}
